<template>
	<div class="pageContainer">
		<index :type="type"></index>

	</div>
</template>

<script>
import Index from '@/components/data/index.vue';
export default {
	name: 'FrontendPcBigdataPrepare',
	components: { Index },
	data() {
		return {
			type: 1, //1代表 拟上市  2正在公告  3 成交
		}
	}
};
</script>

<style lang="scss" scoped>
.pageContainer {
	width: 100%;
	overflow-y: scroll;
}
</style>